
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function parseJSON(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Money formatter – 1:1 copy of working logic from VariantPicker
  function formatMoney(cents, format = '${{amount}}') {
    if (typeof cents == 'string') {
      cents = ~~(cents).replace('.', '');
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      const sNumber = (number / 100.0).toFixed(precision);
      const parts = sNumber.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }

    const match = formatString.match(placeholderRegex);
    if (match) {
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
    }

    return formatString.replace(placeholderRegex, value);
  }

  const productData = parseJSON('product-options-variant-data');
  const fabricData = parseJSON('CylindoFabricData');
  if (!productData || !productData.product) return;

  const tabsRoot = document.getElementById('FabricTabs');
  if (!tabsRoot) return;

  // ----- Render hover cards from fabric data -----
  function renderFabricHoverCards() {
    if (!fabricData || !fabricData.fabrics || !Array.isArray(fabricData.fabrics)) return;
    
    // Find all hover card containers (desktop and mobile)
    const hoverContainers = document.querySelectorAll('[cylindo-fabric-hover-cards]');
    if (hoverContainers.length === 0) return;
    
    hoverContainers.forEach(container => {
      const isMobile = container.getAttribute('cylindo-fabric-mobile') === 'true';
      
      // Clear existing content
      container.innerHTML = '';
      
      // Render each fabric card
      fabricData.fabrics.forEach(fabric => {
        const value = fabric.fabric;
        const colorSplit = value.split(' / ');
        const fabricWithDescription = colorSplit[0];
        const color = colorSplit[1] || '';
        
        const { careInstructions, descriptionContent, descriptionLabel, material, petKidFriendly, image } = fabric;
        
        // Create hover card element
        const hoverCard = document.createElement('div');
        hoverCard.className = 'cylindoVariant__hover';
        hoverCard.setAttribute('data-value', value);
        
        // Build image URL with responsive sizes
        const imageDataSrc = image.url.replace('width=100', 'width={width}').replace('height=100', 'height={height}');
        
        if (isMobile) {
          // Mobile: Create modal structure directly inside container (like TypeScript version)
          const modal = document.createElement('div');
          modal.className = 'popupModal';
          // Modal ID should match exactly with toggle-modal attribute (no CSS.escape for ID)
          modal.id = `modal-${value}`;
          // Initially hidden (will be shown when opened)
          modal.style.display = 'none';
          modal.innerHTML = `
            <div class="popupModal__mask"></div>
            <div class="popupModal__box">
              <div class="popupModal__header">
                <button class="popupModal__close" aria-label="Close modal">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" focusable="false">
                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M10.714 1.286l-9.428 9.428M1.286 1.286l9.428 9.428" stroke-width=".85714"/>
                    </g>
                  </svg>
                </button>
              </div>
              <div class="popupModal__content" role="dialog" aria-modal="true">
                <div class="cylindoVariant__hover" data-value="${value}">
                  ${createDesktopCardHTML(fabricWithDescription, color, image, imageDataSrc, careInstructions, descriptionContent, descriptionLabel, material, petKidFriendly)}
                </div>
              </div>
            </div>
          `;
          // Append modal directly to container (not body)
          container.appendChild(modal);
        } else {
          // Desktop: Just the card content
          hoverCard.innerHTML = createDesktopCardHTML(fabricWithDescription, color, image, imageDataSrc, careInstructions, descriptionContent, descriptionLabel, material, petKidFriendly);
          container.appendChild(hoverCard);
        }
      });
    });
  }

  // Set hover fabric prices – 1:1 clone of VariantSelect.updateHoverCards logic
  function updateHoverCardPrices() {
    if (!productData || !productData.variants || !productData.options) return;

    const fabricIdx = productData.options.indexOf('Fabric');
    if (fabricIdx === -1) return;

    // Build current options array in the same order as productData.options
    const selection = getCurrentSelection();
    const baseOptions = productData.options.map((name) => selection[name] || null);

    const hoverCards = document.querySelectorAll('[cylindo-fabric-hover-cards] .cylindoVariant__hover');
    if (!hoverCards.length) return;

    hoverCards.forEach((card) => {
      const priceEl = card.querySelector('[cylindo-fabric-price]');
      const fabric = card.getAttribute('data-value');
      if (!priceEl || !fabric) return;

      const options = baseOptions.slice();
      options[fabricIdx] = fabric;

      const variant = productData.variants.find((v) => {
        return Array.isArray(v.options) && v.options.every((opt, i) => options[i] === opt);
      });

      if (variant && typeof variant.price !== 'undefined') {
        priceEl.textContent = formatMoney(variant.price);
      }
    });
  }

  // Helper function to create desktop card HTML
  function createDesktopCardHTML(fabricWithDescription, color, image, imageDataSrc, careInstructions, descriptionContent, descriptionLabel, material, petKidFriendly) {
    return `
      <div class="cylindoVariant__hover-header">
        <div class="cylindoVariant__hover-img">
          <img 
            src="${image.url}"
            class="inlineImg lazyautosizes lazyload"
            style="--focal-x: 50%; --focal-y: 50%;"
            data-src="${imageDataSrc}"
            data-widths="[540, 720, 900, 1080, 1250, 1440, 1680, 1920]"
            data-aspectratio="${image.aspectRatio}"
            data-sizes="auto"
            alt="${image.alt || ''}" 
          />
        </div>
        <div class="cylindoVariant__hover-fabric">
          <p class="cylindoVariant__hover-fabricGroup">${fabricWithDescription}</p>
          <h6 class="cylindoVariant__hover-fabricTitle">${color}</h6>
          <p cylindo-fabric-price></p>
        </div>
      </div>
      <div class="cylindoVariant__hover-content">
        <hr />
        <ul class="cylindoVariant__hover-details">
          <li>
            <span class="cylindoVariant__hover-detailsLabel">Material</span>
            <span class="cylindoVariant__hover-detailsValue">${material || ''}</span>
          </li>
          <li>
            <span class="cylindoVariant__hover-detailsLabel">Care Instructions</span>
            <span class="cylindoVariant__hover-detailsValue">${careInstructions || ''}</span>
          </li>
          <li>
            <span class="cylindoVariant__hover-detailsLabel">Pet/Kid Friendly</span>
            <span class="cylindoVariant__hover-detailsValue">${petKidFriendly || ''}</span>
          </li>
        </ul>
        <hr />
        <div class="cylindoVariant__hover-valueprop">
          <p class="cylindoVariant__hover-valuepropLabel">${descriptionLabel || ''}</p>
          <p class="cylindoVariant__hover-valuepropContent">${descriptionContent || ''}</p>
        </div>
      </div>
    `;
  }

  // ----- Modal handling for mobile View Details buttons (matching TypeScript ModalManager) -----
  function initModalHandling() {
    let currentModal = null;
    
    // Handle View Details button clicks
    document.addEventListener('click', (e) => {
      const toggleBtn = /** @type {HTMLElement | null} */ (e.target?.closest?.('[toggle-modal]'));
      if (!toggleBtn) return;
      
      const modalId = toggleBtn.getAttribute('toggle-modal');
      if (!modalId) return;
      
      // Use querySelector with attribute selector to handle IDs with special characters
      const modal = document.querySelector(`[id="${modalId}"]`);
      if (!modal) return;
      
      // Close previous modal if open
      if (currentModal && currentModal !== modal) {
        closeModal(currentModal);
      }
      
      // Open new modal (matching TypeScript ModalManager.open())
      openModal(modal);
      currentModal = modal;
    });
    
    // Close modal handlers
    document.addEventListener('click', (e) => {
      const target = /** @type {HTMLElement} */ (e.target);
      
      // Close button click
      if (target.closest('.popupModal__close')) {
        const modal = target.closest('.popupModal');
        if (modal) {
          e.preventDefault();
          e.stopPropagation();
          closeModal(modal);
          currentModal = null;
        }
        return;
      }
      
      // Mask click to close
      if (target.classList.contains('popupModal__mask')) {
        const modal = target.closest('.popupModal');
        if (modal) {
          closeModal(modal);
          currentModal = null;
        }
        return;
      }
    });
    
    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && currentModal) {
        closeModal(currentModal);
        currentModal = null;
      }
    });
    
    // Open modal function (matching TypeScript ModalManager)
    function openModal(modal) {
      const mask = modal.querySelector('.popupModal__mask');
      const box = modal.querySelector('.popupModal__box');
      if (!mask || !box) return;
      
      // Block scroll
      if (!document.body.classList.contains('has-dialog')) {
        document.body.classList.add('has-dialog');
      }
      
      // Set initial styles (matching GSAP animations from TypeScript)
      modal.style.display = 'flex';
      box.style.pointerEvents = 'all';
      modal.classList.add('popupModal--opened');
      
      // Animate mask
      mask.style.opacity = '1';
      mask.style.visibility = 'inherit';
      
      // Animate box
      box.style.setProperty('--offset', '0px');
      box.style.opacity = '1';
      box.style.visibility = 'inherit';
    }
    
    // Close modal function (matching TypeScript ModalManager)
    function closeModal(modal) {
      const mask = modal.querySelector('.popupModal__mask');
      const box = modal.querySelector('.popupModal__box');
      if (!mask || !box) return;
      
      // Unblock scroll
      if (document.body.classList.contains('has-dialog')) {
        document.body.classList.remove('has-dialog');
      }
      
      // Animate out
      mask.style.opacity = '0';
      mask.style.visibility = 'hidden';
      
      box.style.opacity = '0';
      box.style.visibility = 'hidden';
      box.style.setProperty('--offset', '150px');
      box.style.pointerEvents = 'none';
      
      // Hide modal after animation
      setTimeout(() => {
        modal.style.display = 'none';
        modal.classList.remove('popupModal--opened');
      }, 300);
    }
  }

  // ----- Hover cards: event delegation (works across re-renders) -----
  function initFabricHoverDelegation() {
    const hoverRoot = document.querySelector('[cylindo-fabric-hover-cards]');
    if (!hoverRoot) return;

    // helper: element onHover get title
    const pickTile = (el) => el && el.closest('.fabric-tile.cylindoVariant__option');

    const onOver = (e) => {
      const tile = pickTile(e.target);
      if (!tile || !tabsRoot.contains(tile)) return;

      const val = tile.getAttribute('data-value') || tile.querySelector('input[type="radio"]')?.value;
      if (!val) return;

      tile.classList.add('hovered');

      // remove exisitng hover, apply on matched one
      hoverRoot.querySelectorAll('.cylindoVariant__hover[hovered]')
        .forEach(n => n.removeAttribute('hovered'));

      hoverRoot.querySelectorAll(`.cylindoVariant__hover[data-value="${CSS.escape(val)}"]`)
        .forEach(n => n.setAttribute('hovered', ''));
    };

    const onOut = (e) => {
      const tile = pickTile(e.target);
      if (!tile) return;

      if (tile.contains(e.relatedTarget)) return;

      const val = tile.getAttribute('data-value') || tile.querySelector('input[type="radio"]')?.value;
      tile.classList.remove('hovered');
      if (!val) return;

      hoverRoot.querySelectorAll(`.cylindoVariant__hover[data-value="${CSS.escape(val)}"]`)
        .forEach(n => n.removeAttribute('hovered'));
    };

    tabsRoot.addEventListener('pointerover', onOver);
    tabsRoot.addEventListener('pointerout', onOut);
  }



  // ===== Hide-by-metafield helper =====
  function shouldHideByMeta(valueForTarget, selection) {

  }


  // ----- Tabs availability helpers -----
  function panelHasItems(panel) {
    return !!panel && !!panel.querySelector('.js-panel-item');
  }
  function setDisabled(btn, disabled) {
    if (!btn) return;
    if (disabled) {
      btn.setAttribute('disabled', '');
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-disabled');
    } else {
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'false');
      btn.classList.remove('is-disabled');
    }
  }
  function setActiveTab(tabKey) {
    const btn = tabsRoot.querySelector(`.fabric-tabs__btn[data-tab="${tabKey}"]`);
    const panel = tabsRoot.querySelector(`#panel-${tabKey}`);
    if (!btn || !panel) return;
    tabsRoot.querySelectorAll('.fabric-tabs__btn').forEach(b => b.classList.remove('is-active'));
    tabsRoot.querySelectorAll('.fabric-tabs__panel').forEach(p => p.classList.remove('is-active'));
    btn.classList.add('is-active');
    panel.classList.add('is-active');
  }
  function refreshTabsAvailability() {
    const has = {
      instock: panelHasItems(tabsRoot.querySelector('#panel-instock')),
      mto: panelHasItems(tabsRoot.querySelector('#panel-mto')),
      sale: panelHasItems(tabsRoot.querySelector('#panel-sale')),
    };

    setDisabled(tabsRoot.querySelector('.fabric-tabs__btn[data-tab="instock"]'), !has.instock);
    setDisabled(tabsRoot.querySelector('.fabric-tabs__btn[data-tab="mto"]'), !has.mto);
    setDisabled(tabsRoot.querySelector('.fabric-tabs__btn[data-tab="sale"]'), !has.sale);

    // agar user ne tab khud click kiya hai aur us panel me items hain => respect user
    const activeKey = tabsRoot.querySelector('.fabric-tabs__btn.is-active')?.dataset.tab;
    const keepUser = tabsRoot.__userPicked && activeKey && has[activeKey];

    if (!keepUser) {
      // PRIORITY: Instock -> MTO -> Sale
      const next = has.instock ? 'instock' : (has.mto ? 'mto' : (has.sale ? 'sale' : null));
      if (next) setActiveTab(next);
      else {
        // sab empty ho to sabse active hata do
        tabsRoot.querySelectorAll('.fabric-tabs__btn,.fabric-tabs__panel')
          .forEach(n => n.classList.remove('is-active'));
      }
    }

    // optional: ek hi bucket visible ho to head hide
    // const visibleCount = (has.instock?1:0) + (has.mto?1:0) + (has.sale?1:0);
    // tabsRoot.querySelector('.fabric-tabs__head')?.classList
    //   .toggle('is-hidden', visibleCount <= 1);
  }
  // ===== Initial auto-pick (In-Stock first, else MTO) =====
  function selectFirstInPanel(panelKey) {
    const panel = tabsRoot.querySelector(`#panel-${panelKey}`);
    if (!panel) return false;

    const firstTile = panel.querySelector('.js-panel-item input[type="radio"]');
    if (!firstTile) return false;

    // Activate the tab first
    setActiveTab(panelKey);

    // Select & sync - use a delay to ensure tab is active and visible
    setTimeout(() => {
      // Re-query to ensure we have the latest element
      const currentPanel = tabsRoot.querySelector(`#panel-${panelKey}`);
      const currentInput = currentPanel?.querySelector('.js-panel-item input[type="radio"]');
      
      if (!currentInput) return;
      
      if (!currentInput.checked) {
        // Set checked state
        currentInput.checked = true;
        
        // Update label state
        const label = currentInput.closest('.fabric-tile');
        if (label) {
          label.classList.add('is-selected');
          // Remove is-selected from all other tiles
          document.querySelectorAll('.fabric-tile').forEach(tile => {
            if (tile !== label) tile.classList.remove('is-selected');
          });
        }

        // Fire events in sequence to ensure variant-picker picks it up
        // Use requestAnimationFrame to ensure DOM is ready
        requestAnimationFrame(() => {
          // Fire input event
          currentInput.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          
          // Fire change event after a small delay
          setTimeout(() => {
            currentInput.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
            
            // Also try clicking the input directly (more reliable)
            setTimeout(() => {
              // Try clicking the input itself
              if (currentInput && document.contains(currentInput)) {
                currentInput.click();
              }
              
              // Also try clicking the label as fallback
              if (label && document.contains(label)) {
                setTimeout(() => {
                  label.click();
                }, 50);
              }
            }, 50);
          }, 50);
        });
      }
    }, 150);

    return true;
  }

  function autoPickOnLoad() {
    const urlVariant = window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
    if (tabsRoot.__userPicked) return;
    if (urlVariant) return;

    // Ensure availability flags are up-to-date
    refreshTabsAvailability();

    // Try In-Stock, else MTO
    if (selectFirstInPanel('instock')) return;
    selectFirstInPanel('mto');
  }

  // Auto-click first available variant on page load (for furniture_new template)
  function autoClickFirstAvailableVariant() {
    const urlVariant = window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return;

    // Check if this is furniture_new template
    const productGalleryEl = document.querySelector('[product-gallery]');
    const isFurnitureNew = (productGalleryEl?.dataset?.templateSuffix === 'furniture_new') ||
                           (document.body.classList.contains('template-product') && 
                            window.location.pathname.includes('furniture'));

    if (!isFurnitureNew) return;

    // Wait for variant-picker and tabs to be ready
    const checkReady = (attempts = 0) => {
      const variantPicker = document.querySelector('variant-picker');
      const instockPanel = tabsRoot.querySelector('#panel-instock');
      const mtoPanel = tabsRoot.querySelector('#panel-mto');
      
      const isReady = variantPicker && 
                      variantPicker.variants && 
                      variantPicker.variants.length > 0 &&
                      (instockPanel || mtoPanel); // At least one panel should exist
      
      if (isReady) {
        // Variant picker and panels are ready, now call autoPickOnLoad
        setTimeout(() => {
          // Ensure tabs are refreshed first
          refreshTabsAvailability();
          // Then auto-pick
          autoPickOnLoad();
        }, 150);
      } else if (attempts < 30) {
        // Retry after 100ms (max 3 seconds)
        setTimeout(() => checkReady(attempts + 1), 100);
      }
    };

    // Start checking after a small delay to let DOM settle
    setTimeout(() => {
      checkReady();
    }, 300);
  }



  // > 12 show more button
  // ===== View More (simple + group-aware) =====
  const SHOW_LIMIT = Number(tabsRoot?.dataset.showLimit || 12);

  function applyViewMore(panelEl, limit = SHOW_LIMIT) {
    // reset previous state
    panelEl.querySelectorAll('.fabric-tabs__more').forEach(n => n.remove());
    panelEl.querySelectorAll('.is-hidden').forEach(n => n.classList.remove('is-hidden'));

    const items = [...panelEl.querySelectorAll('.newLabelContainer')];
    if (items.length <= limit) return;

    // hide items beyond limit
    items.forEach((el, i) => { if (i >= limit) el.classList.add('is-hidden'); });

    // hide empty groups (only if groups exist; colors me groups nahi hote)
    [...panelEl.querySelectorAll('.fabric-group__items')].forEach(wrap => {
      const hasVisible = !!wrap.querySelector('.newLabelContainer:not(.is-hidden)');
      const title = wrap.previousElementSibling;
      if (!hasVisible) {
        wrap.classList.add('is-hidden');
        if (title && title.classList.contains('cylindoVariant__groupTitle')) {
          title.classList.add('is-hidden');
        }
      }
    });

    // add "View more" button
    const moreWrap = document.createElement('div');
    moreWrap.className = 'fabric-tabs__more';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fabric-tabs__moreBtn';
    btn.textContent = `View more (${items.length - limit})`;
    btn.addEventListener('click', () => {
      items.forEach(el => el.classList.remove('is-hidden'));
      panelEl.querySelectorAll('.fabric-group__items.is-hidden, .cylindoVariant__groupTitle.is-hidden')
        .forEach(el => el.classList.remove('is-hidden'));
      moreWrap.remove();
    });

    moreWrap.appendChild(btn);
    panelEl.appendChild(moreWrap);
  }


  const variants = productData.variants || [];
  const optionsWithValues = productData.options_with_values || [];

  // TARGET option (Fabric > Color > first)
  const TARGET_OPTION_NAME =
    (optionsWithValues.find(o => o.name === 'Fabric')?.name) ||
    (optionsWithValues.find(o => o.name === 'Color')?.name) ||
    (optionsWithValues[0]?.name || 'Fabric');

  const targetOption = optionsWithValues.find(o => o.name === TARGET_OPTION_NAME);
  const nonTargetOptions = optionsWithValues.filter(o => o.name !== TARGET_OPTION_NAME);

  const HAS_FABRIC = optionsWithValues.some(o => o.name === 'Fabric');
  const IS_COLOR_ONLY = !HAS_FABRIC && TARGET_OPTION_NAME === 'Color';

  const variantMetaList = productData.variants_metafields || [];
  const productMetafields = productData.product_metafields || {};
  const INVENTORY_KEY = (tabsRoot.dataset.inventoryKey || '5200 - MVN Warehouse').trim().toLowerCase();

  // variantId -> metafields
  const byIdMeta = new Map();
  variantMetaList.forEach((m, i) => { const v = variants[i]; if (v) byIdMeta.set(v.id, m); });

  // swatch images from option values
  const swatchByValue = new Map();
  if (targetOption && Array.isArray(targetOption.values)) {
    targetOption.values.forEach(v => {
      const name = v?.name || v?.value || v;
      let img = v?.swatch?.image || null;
      // Handle different image formats (string URL or object with src)
      if (img && typeof img === 'object' && img.src) {
        img = img.src;
      } else if (img && typeof img === 'object' && img.url) {
        img = img.url;
      }
      swatchByValue.set(name, img);
    });
  }

  // Optional metaobject fabric images (for fabrics)
  const metaFabricImg = new Map();
  if (fabricData && Array.isArray(fabricData.fabrics)) {
    fabricData.fabrics.forEach(x => {
      if (x?.fabric && x?.image?.url) metaFabricImg.set(x.fabric, x.image.url);
    });
  }

  function parseFabricLabel(value) {
    const lr = String(value).split(' / ');
    const left = (lr[0] || '').trim();
    const color = (lr[1] || '').trim();
    const parts = left.split(',').map(s => s.trim());
    const fabric = parts[0] || '';
    const desc = parts.slice(1).join(', ') || '';
    const groupTitle = desc ? `${fabric}, ${desc}` : fabric;
    return { fabric, desc, color, groupTitle };
  }

  function isAvailableAnywhere(variantId) {
    const v = variants.find(x => x.id === variantId);
    if (!v) return false;

    const meta = byIdMeta.get(variantId);
    if (meta && meta.custom && meta.custom.availability === false) return false;

    // If inventory_policy is continue (continue selling when out of stock), variant is available
    const inventoryPolicy = v.inventory_policy || v.inventoryPolicy || meta?.inventory_policy;
    if (inventoryPolicy === 'continue' || inventoryPolicy === 'Continue') return true;

    if (!meta) return !!v.available;

    const inv = meta.inventory || {};
    if (inv.available_at_locations != null) {
      const n = Number(inv.available_at_locations);
      if (!Number.isNaN(n) && n > 0) return true;
    }
    const locs = inv.available_counts_per_location;
    const getQty = r => Number(typeof r?.available === 'number' ? r.available : (r?.available || 0)) || 0;

    if (Array.isArray(locs)) {
      if (locs.length && Array.isArray(locs[0])) return locs.reduce((a, e) => a + getQty(e?.[1]), 0) > 0;
      return locs.reduce((a, r) => a + getQty(r), 0) > 0;
    }
    if (locs && typeof locs === 'object') return Object.values(locs).reduce((a, r) => a + getQty(r), 0) > 0;

    return !!v.available;
  }

  function isInStockAtLocation(variantId) {
    const meta = byIdMeta.get(variantId);
    const locs = meta?.inventory?.available_counts_per_location;

    const matchOne = (rec) => {
      const nm = (rec?.name || rec?.location?.name || '').trim().toLowerCase();
      const qty = Number(typeof rec?.available === 'number' ? rec.available : (rec?.available || 0)) || 0;
      return nm === INVENTORY_KEY && qty > 0;
    };

    if (locs) {
      if (Array.isArray(locs)) {
        if (locs.length && Array.isArray(locs[0])) {
          if (locs.some(e => matchOne(e?.[1]))) return true;
        } else {
          if (locs.some(matchOne)) return true;
        }
      } else if (locs && typeof locs === 'object') {
        if (Object.values(locs).some(matchOne)) return true;
      }
    }

    // Last check: if inventory is 0 and "Continue selling when out of stock" is ON, put in MTO/Sale (not in-stock)
    const v = variants.find(x => x.id === variantId);
    if (v) {
      const inventoryPolicy = v.inventory_policy || v.inventoryPolicy || meta?.inventory_policy;
      const inventoryQty = v.inventory_quantity || 0;

      // If inventory is 0 AND continue policy is ON, return false (goes to MTO/Sale, not in-stock)
      if (inventoryQty <= 0 && (inventoryPolicy === 'continue' || inventoryPolicy === 'Continue')) {
        return false;
      }
    }

    return false;
  }

  function getLeadTimeForVariant(v) {
    const meta = byIdMeta.get(v.id);
    return (meta?.new_my_fields?.lead_time)
      || (productMetafields?.new_my_fields?.lead_time)
      || '';
  }

  function getCurrentSelection() {
    // If user landed on PDP with ?variant= (from SLP/header search),
    // prefer that variant's options as the source of truth on first render.
    const urlVariantRaw =
      window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
    const urlVariantId = urlVariantRaw ? Number(String(urlVariantRaw).trim()) : NaN;
    const urlVariantObj = Number.isFinite(urlVariantId)
      ? variants.find(v => Number(v.id) === urlVariantId)
      : null;

    const sel = {};
    optionsWithValues.forEach(o => {
      const n = o.name;
      // supports "Size" and "options[Size]" (and lowercase)
      const q = [
        `input[name="${CSS.escape(n)}"]:checked`,
        `input[name="options[${CSS.escape(n)}]"]:checked`,
        `input[name="${CSS.escape(n.toLowerCase())}"]:checked`,
        `input[name="options[${CSS.escape(n.toLowerCase())}]"]:checked`
      ].join(',');

      const inp = document.querySelector(q);
      if (inp) {
        sel[n] = inp.value;
      } else {
        const pos = (o.position || 1) - 1;
        sel[n] = urlVariantObj?.options?.[pos]
          || productData.product?.selected_or_first_available_variant?.options?.[pos]
          || productData.product?.variants?.[0]?.options?.[pos]
          || null;
      }
    });
    return sel;
  }

  function variantMatches(selection, valueForTarget) {
    const nameToPos = new Map(optionsWithValues.map(o => [o.name, (o.position || 1) - 1]));
    return variants.filter(v => {
      for (const o of nonTargetOptions) {
        const pos = nameToPos.get(o.name);
        if (pos == null) continue;
        const need = selection[o.name];
        if (need && v.options[pos] !== need) return false;
      }
      if (targetOption) {
        const fpos = nameToPos.get(TARGET_OPTION_NAME);
        if (fpos == null) return false;
        if (v.options[fpos] !== valueForTarget) return false;
      }
      return true;
    });
  }

  // ===== Groups (instock / mto / sale) =====
  function computeGroups(selection) {
    const out = { instock: [], mto: [], sale: [] };
    if (!targetOption || !Array.isArray(targetOption.values)) return out;

    const seen = new Set();
    targetOption.values.forEach(val => {
      const value = val?.name || val?.value || val;
      if (!value || seen.has(value)) return;

      const matched = variantMatches(selection, value);
      if (!matched.length) return;

      const available = matched.filter(v => isAvailableAnywhere(v.id));
      if (!available.length) return;

      const chosen = available[0];
      const leadTime = getLeadTimeForVariant(chosen);
      const anySale = available.some(v => (v.compare_at_price && v.compare_at_price > v.price));
      const anyInStockHere = available.some(v => isInStockAtLocation(v.id));

      const entry = { value, leadTime, instockHere: anyInStockHere, variant: chosen };
      if (anySale) out.sale.push(entry);
      if (anyInStockHere) out.instock.push({ value, leadTime, variant: chosen });
      else out.mto.push({ value, leadTime, variant: chosen });

      seen.add(value);
    });

    return out;
  }

  function toTileObjects(arr) {
    return arr.map((obj) => {
      const { value, leadTime, instockHere = false, variant } = obj || {};
      const h = value.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      const p = parseFabricLabel(value);
      
      // Get custom.swatch metafield from variant
      let customSwatch = null;
      if (variant && variant.id) {
        const variantMeta = byIdMeta.get(variant.id);
        if (variantMeta && variantMeta.custom && variantMeta.custom.swatch) {
          customSwatch = variantMeta.custom.swatch.value || variantMeta.custom.swatch;
          // Handle if it's an object with url property
          if (customSwatch && typeof customSwatch === 'object' && customSwatch.url) {
            customSwatch = customSwatch.url;
          }
        }
      }
      
      return {
        value,
        value_handle: h,
        fabric: p.fabric,
        desc: p.desc,
        color: p.color,
        groupTitle: p.groupTitle,
        leadTime,
        swatch_image: swatchByValue.get(value) || null,
        meta_img: metaFabricImg.get(value) || null,
        custom_swatch: customSwatch,
        instockHere: !!instockHere
      };
    });
  }

  // ===== Helpers for Color grid IDs / names =====
  function getProductFormId() {
    const form = document.querySelector('form[id^="product-form-"]');
    return form ? form.id : null;
  }
  function optionInputNameFor(optName) {
    const exact = document.querySelector(`input[name="options[${CSS.escape(optName)}]"]`);
    if (exact) return `options[${optName}]`;
    const lo = optName.toLowerCase();
    const lower = document.querySelector(`input[name="options[${CSS.escape(lo)}]"]`);
    if (lower) return `options[${lo}]`;
    return optName;
  }
  const handleize = (s) => String(s).toLowerCase()
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const fallbackSwatchURL = (val) => {
    const h = handleize(val);
    const host = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : location.host;
    return `//${host}/cdn/shop/files/${h}_84x84.png`;
  };

  // ===== THEME-STYLE COLOR GRID inside each TAB panel =====
  function renderColorPanel(panelEl, tiles, selection, blockTitle) {
    panelEl.innerHTML = '';
    if (!tiles.length) return;

    const leadSet = new Set(tiles.map(t => t.leadTime).filter(Boolean));
    const header = document.createElement('div');
    header.className = 'product-options__header';
    header.innerHTML = `
      <hr class="product-options__option-divider">
      ${leadSet.size === 1 ? `<p class="product-options__headerLead">Lead Time: ${[...leadSet][0]}</p>` : ''}`;
    panelEl.appendChild(header);

    const byLead = new Map();
    tiles.forEach(t => {
      const lt = t.leadTime || '';
      if (!byLead.has(lt)) byLead.set(lt, []);
      byLead.get(lt).push(t);
    });

    const formId = (function () {
      const f = document.querySelector('form[id^="product-form-"]');
      return f ? f.id : null;
    })();
    const inputNm = (function (optName) {
      if (document.querySelector(`input[name="options[${CSS.escape(optName)}]"]`)) return `options[${optName}]`;
      const lo = optName.toLowerCase();
      if (document.querySelector(`input[name="options[${CSS.escape(lo)}]"]`)) return `options[${lo}]`;
      return optName;
    })(TARGET_OPTION_NAME);

    const current = selection[TARGET_OPTION_NAME];

    const handleize = (s) => String(s).toLowerCase()
      .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const fallbackSwatchURL = (val) => {
      const h = handleize(val);
      const host = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : location.host;
      return `//${host}/cdn/shop/files/${h}_84x84.png`;
    };

    byLead.forEach((items, lt) => {
      if (leadSet.size > 1 && lt) {
        const sub = document.createElement('div');
        sub.className = 'product-options__header';
        sub.innerHTML = `<p class="product-options__headerLead">Lead time: ${lt}</p>`;
        panelEl.appendChild(sub);
      }

      const grid = document.createElement('div');
      grid.className = 'product-options__option-grid color-grid';
      panelEl.appendChild(grid);

      items.forEach(t => {
        // if (shouldHideByMeta(t.value, selection)) return; 
        const id = `option-${TARGET_OPTION_NAME.toLowerCase()}-${t.value_handle}-${Math.random().toString(36).slice(2, 7)}`;

        const wrap = document.createElement('div');
        wrap.className = 'product-options__option-value js-panel-item'; // ⬅️ mark item

        const input = document.createElement('input');
        input.type = 'radio';
        input.className = 'swatch-input__input';
        input.id = id;
        input.name = inputNm;
        input.value = t.value;
        if (formId) input.setAttribute('form', formId);
        if (current === t.value) input.checked = true;
        // input.addEventListener('change', ()=>{
        //   input.dispatchEvent(new Event('input',  { bubbles:true }));
        //   input.dispatchEvent(new Event('change', { bubbles:true }));
        // });

        const label = document.createElement('label');
        label.className = 'swatch-input__label swatch-input__label--square';
        label.setAttribute('for', id);
        label.setAttribute('title', t.value);

        const sw = document.createElement('span');
        sw.className = 'swatch swatch--square';
        // Priority: swatch_image > meta_img > custom.swatch metafield > fallback file URL
        let imgUrl = t.swatch_image || t.meta_img || t.custom_swatch || fallbackSwatchURL(t.value);
        
        // Handle different URL formats
        let finalUrl = '';
        if (imgUrl) {
          // If it's already a url() format, extract the URL
          if (imgUrl.startsWith('url(')) {
            finalUrl = imgUrl.match(/url\(['"]?([^'"]+)['"]?\)/)?.[1] || imgUrl.replace(/^url\(['"]?|['"]?\)$/g, '');
          } else {
            finalUrl = imgUrl;
          }
        }
        
        // Set both CSS custom property and direct background-image for compatibility
        const styleParts = ['--swatch--color: ;'];
        if (finalUrl) {
          styleParts.push(`--swatch--background: url('${finalUrl}');`);
          styleParts.push(`background-image: url('${finalUrl}');`);
          styleParts.push('background-size: cover;');
          styleParts.push('background-position: center;');
          styleParts.push('background-repeat: no-repeat;');
        }
        
        sw.setAttribute('style', styleParts.join(' '));

        const text = document.createElement('span');
        text.textContent = t.value;

        label.appendChild(sw);
        label.appendChild(text);
        wrap.appendChild(input);
        wrap.appendChild(label);
        grid.appendChild(wrap);
      });
    });

    applyViewMore(panelEl);
    attachIOSVariantTapFix(panelEl);
  }



  // ===== FABRIC renderers (unchanged) =====
  function renderInstockPanel(panelEl, tiles, selection) {
    panelEl.innerHTML = '';
    if (!tiles.length) return;

    const groups = new Map(); // leadTime => items[]
    tiles.forEach(t => {
      const key = t.leadTime || '—';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(t);
    });

    const currentVal = selection && selection[TARGET_OPTION_NAME];

    groups.forEach((items, lt) => {
      if (lt && lt !== '—') {
        const hdr = document.createElement('div');
        hdr.className = 'product-options__header';
        hdr.innerHTML = `<p class="product-options__headerLead" ltcustom stockVariant>Lead time: ${lt}</p>`;
        panelEl.appendChild(hdr);
      }

      const wrap = document.createElement('div');
      wrap.className = 'fabric-tiles';
      panelEl.appendChild(wrap);

      items.forEach(t => {
        // if (shouldHideByMeta(t.value, selection)) return;
        const item = document.createElement('div');
        item.className = 'newLabelContainer';
        const label = document.createElement('label');
        label.className = 'fabric-tile cylindoVariant__option js-panel-item'; // ⬅️ mark item
        label.tabIndex = 0;
        label.setAttribute('data-value', t.value);
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = TARGET_OPTION_NAME;
        input.id = `Fabric_${t.value_handle}`;
        input.value = t.value;
        input.classList.add('visually-hidden');
        label.setAttribute('for', input.id);
        if (currentVal === t.value) {
          input.checked = true;
          label.classList.add('is-selected');
        }
        input.addEventListener('change', () => {
          label.classList.add('is-selected');
          document.querySelectorAll('.fabric-tile').forEach(x => { if (x !== label) x.classList.remove('is-selected'); });
          // input.dispatchEvent(new Event('input',{bubbles:true}));
          // input.dispatchEvent(new Event('change',{bubbles:true}));
        });

        const sw = document.createElement('div');
        sw.className = 'cylindoVariant__optionDisplay';
        const imgSrc = t.swatch_image || t.meta_img || null;
        if (imgSrc) {
          const img = document.createElement('img');
          img.src = imgSrc; img.alt = t.value;
          sw.appendChild(img);
        } else {
          sw.textContent = t.fabric || '—';
        }

        const pf = document.createElement('p');
        pf.className = 'cylindoVariant__option-fabric';
        pf.textContent = t.fabric || '';

        const pc = document.createElement('p');
        pc.className = 'cylindoVariant__option-color';
        pc.textContent = t.color || '';

        const pd = document.createElement('p');
        pd.className = 'cylindoVariant__option-desc';
        pd.textContent = t.desc || '';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('toggle-modal', 'modal-' + t.value);
        btn.textContent = 'View Details';
        // BRUTE FORCE: any tap on tile selects radio (except the modal button)
        label.addEventListener('click', (e) => {
          if (e.target.closest('button,[toggle-modal]')) return; // don't change selection when opening modal
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        label.appendChild(input);
        label.appendChild(sw);
        label.appendChild(pf);
        label.appendChild(pc);
        label.appendChild(pd);
        item.appendChild(label);  // label first
        item.appendChild(btn);    // button as sibling of label
        wrap.appendChild(item);
      });
    });

    applyViewMore(panelEl);
    attachIOSVariantTapFix(panelEl);
  }


  function renderMtoLike(panelEl, tiles, selection) {
    renderInstockPanel(panelEl, tiles, selection);
  }
  function renderSalePanel(panelEl, tiles, selection) {
    panelEl.innerHTML = '';
    if (!tiles.length) return;

    // split: in-stock first, then MTO
    const instockFirst = tiles.filter(t => t.instockHere);
    const mtoLater = tiles.filter(t => !t.instockHere);

    // local helper: same layout as renderInstockPanel (by lead time)
    const renderBlock = (list) => {
      if (!list.length) return;

      const groups = new Map(); // leadTime => items[]
      list.forEach(t => {
        const key = t.leadTime || '—';
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(t);
      });

      const currentVal = selection && selection[TARGET_OPTION_NAME];

      groups.forEach((items, lt) => {
        if (lt && lt !== '—') {
          const hdr = document.createElement('div');
          hdr.className = 'product-options__header';
          hdr.innerHTML = `<p class="product-options__headerLead" ltcustom stockVariant>Lead time: ${lt}</p>`;
          panelEl.appendChild(hdr);
        }

        const wrap = document.createElement('div');
        wrap.className = 'fabric-tiles';
        panelEl.appendChild(wrap);

        items.forEach(t => {
          // if (shouldHideByMeta(t.value, selection)) return;
          const item = document.createElement('div');
          item.className = 'newLabelContainer';
          const label = document.createElement('label');
          label.className = 'fabric-tile cylindoVariant__option js-panel-item';
          label.tabIndex = 0;
          label.setAttribute('data-value', t.value);

          const input = document.createElement('input');
          input.type = 'radio';
          input.name = TARGET_OPTION_NAME;
          input.id = `Fabric_${t.value_handle}`;
          input.value = t.value;
          input.hidden = true;

          if (currentVal === t.value) {
            input.checked = true;
            label.classList.add('is-selected');
          }

          input.addEventListener('change', () => {
            label.classList.add('is-selected');
            document.querySelectorAll('.fabric-tile').forEach(x => {
              if (x !== label) x.classList.remove('is-selected');
            });
          });

          const sw = document.createElement('div');
          sw.className = 'cylindoVariant__optionDisplay';
          const imgSrc = t.swatch_image || t.meta_img || null;
          if (imgSrc) {
            const img = document.createElement('img');
            img.src = imgSrc; img.alt = t.value;
            sw.appendChild(img);
          } else {
            sw.textContent = t.fabric || '—';
          }

          const pf = document.createElement('p');
          pf.className = 'cylindoVariant__option-fabric';
          pf.textContent = t.fabric || '';

          const pc = document.createElement('p');
          pc.className = 'cylindoVariant__option-color';
          pc.textContent = t.color || '';

          const pd = document.createElement('p');
          pd.className = 'cylindoVariant__option-desc';
          pd.textContent = t.desc || '';

          const btn = document.createElement('button');
          btn.setAttribute('toggle-modal', 'modal-' + t.value);
          btn.textContent = 'View Details';

          label.appendChild(input);
          label.appendChild(sw);
          label.appendChild(pf);
          label.appendChild(pc);
          label.appendChild(pd);
          item.appendChild(label);  // label first
          item.appendChild(btn);    // button as sibling of label
          wrap.appendChild(item);
        });
      });
    };

    // render in the wanted order:
    renderBlock(instockFirst);
    renderBlock(mtoLater);

    applyViewMore(panelEl);
  }
  function attachIOSVariantTapFix(root) {
    const tiles = root.querySelectorAll('.fabric-tile.cylindoVariant__option');
    tiles.forEach((label) => {
      if (label.__iosBound) return;
      label.__iosBound = true;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      const handler = (e) => {
        // modal/open buttons ko ignore
        // if (e.target.closest('button,[toggle-modal]')) return;

        // kill native path (iOS label quirks) + stop other handlers
        // if (e) {
        //   if (e.cancelable) e.preventDefault();
        //   e.stopPropagation();
        //   if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        // }

        // ensure selection + events
        if (!input.checked) {
          // focus helps iOS sometimes
          try { input.focus({ preventScroll: true }); } catch { }
          input.checked = true;
        }
        // fire twice (some themes swallow first)
        const fireOnce = () => {
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        };
        fireOnce();
        requestAnimationFrame(fireOnce);

      };

      // bind on multiple phases to be extra safe on iOS
      label.addEventListener('pointerup', handler, { passive: false });
      label.addEventListener('touchend', handler, { passive: false });
      label.addEventListener('click', handler, { passive: false });
    });
  }


  // ===== Render All =====
  function renderAll() {
    const selection = getCurrentSelection();
    const grouped = computeGroups(selection);
    const instockTile = toTileObjects(grouped.instock);
    const mtoTile = toTileObjects(grouped.mto);
    const saleTile = toTileObjects(grouped.sale);

    const instockPanel = $('#panel-instock', tabsRoot);
    const mtoPanel = $('#panel-mto', tabsRoot);
    const salePanel = $('#panel-sale', tabsRoot);

    if (IS_COLOR_ONLY) {
      // Tabs visible + theme swatch grid inside panels
      renderColorPanel(instockPanel, instockTile, selection, 'In Stock');
      renderColorPanel(mtoPanel, mtoTile, selection, 'Made To Order');
      renderColorPanel(salePanel, saleTile, selection, 'Sale');
    } else {
      // Fabric (or other target) = your existing tiles UI
      renderInstockPanel(instockPanel, instockTile, selection);
      renderMtoLike(mtoPanel, mtoTile, selection);
      renderSalePanel(salePanel, saleTile, selection);
    }
    attachIOSVariantTapFix(tabsRoot);

    // If the current variant/selection belongs to a specific tab (instock/mto/sale),
    // ensure that tab is active. This prevents "red sofa" (variant URL) landing on
    // the wrong tab due to default priority (instock first) and avoids unchecking
    // the currently selected value.
    (function syncActiveTabToSelection() {
      const currentVal = selection[TARGET_OPTION_NAME];
      if (!currentVal) return;

      const inputName = optionInputNameFor(TARGET_OPTION_NAME);
      const selector = `input[name="${CSS.escape(inputName)}"][value="${CSS.escape(currentVal)}"]`;

      const keys = ['instock', 'mto', 'sale'];
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const panel = tabsRoot.querySelector(`#panel-${key}`);
        if (!panel) continue;
        if (panel.querySelector(selector)) {
          // Treat as user-picked so refreshTabsAvailability respects it.
          tabsRoot.__userPicked = true;
          setActiveTab(key);
          return;
        }
      }
    })();

    // safety: if current selection is not in active tab, uncheck it
    const activePanel = $('.fabric-tabs__panel.is-active', tabsRoot);
    const currentVal = selection[TARGET_OPTION_NAME];
    if (activePanel && currentVal) {
      const inActive = activePanel.querySelector(
        `input[name="${CSS.escape(optionInputNameFor(TARGET_OPTION_NAME))}"][value="${CSS.escape(currentVal)}"]`
      );
      if (!inActive) {
        const checked = tabsRoot.querySelector(
          `input[name="${CSS.escape(optionInputNameFor(TARGET_OPTION_NAME))}"][value="${CSS.escape(currentVal)}"]`
        );
        if (checked) checked.checked = false;
      }
    }
    refreshTabsAvailability();

    // After panels and tiles are in sync with current selection, update hover card prices
    updateHoverCardPrices();
  }

  // Tabs switching (works for both cases)
  $$('.fabric-tabs__btn', tabsRoot).forEach(btn => {
    if (!btn.__bound) {
      btn.addEventListener('click', () => {
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-disabled')) return;
        tabsRoot.__userPicked = true;                 // ⬅️ ye naya
        $$('.fabric-tabs__btn', tabsRoot).forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const tab = btn.dataset.tab;
        $$('.fabric-tabs__panel', tabsRoot).forEach(p => p.classList.remove('is-active'));
        $(`#panel-${tab}`, tabsRoot)?.classList.add('is-active');
      });
      btn.__bound = true;
    }
  });



  // Re-render on any non-target option change (Size/Orientation etc.)
  function bindNonTargetChange() {
    nonTargetOptions.forEach(o => {
      const n = o.name;
      const sel = [
        `input[name="${CSS.escape(n)}"]`,
        `input[name="options[${CSS.escape(n)}]"]`,
        `input[name="${CSS.escape(n.toLowerCase())}"]`,
        `input[name="options[${CSS.escape(n.toLowerCase())}]"]`
      ].join(',');

      $$(sel).forEach(inp => {
        if (!inp.__fabricTabsBound) {
          inp.addEventListener('change', renderAll);
          inp.addEventListener('input', renderAll);
          inp.__fabricTabsBound = true;
        }
      });
    });

    // delegated fallback if theme re-renders
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t instanceof HTMLInputElement)) return;
      const nm = (t.name || '').toLowerCase();
      const hit = nonTargetOptions.some(o => {
        const on = o.name.toLowerCase();
        return nm === on || nm === `options[${on}]`;
      });
      if (hit) renderAll();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindNonTargetChange();
    renderAll();
    // Render hover cards first, then initialize hover delegation and modal handling
    renderFabricHoverCards();
    updateHoverCardPrices();
    initFabricHoverDelegation();
    initModalHandling();
    setTimeout(autoPickOnLoad, 0);
    // Also call auto-click for furniture_new template
    autoClickFirstAvailableVariant();

    // If user landed with ?variant= from SLP/header search, ensure the theme variant picker
    // receives option change events so price/add-to-cart state initializes without manual clicks.
    // This is intentionally scoped to first load and does NOT run after user interaction.
    setTimeout(() => {
      if (tabsRoot.__urlVariantApplied) return;
      const urlVariantRaw =
        window.__INITIAL_VARIANT_FROM_URL || new URLSearchParams(window.location.search).get('variant');
      const urlVariantId = urlVariantRaw ? Number(String(urlVariantRaw).trim()) : NaN;
      if (!Number.isFinite(urlVariantId)) return;

      const v = variants.find(x => Number(x.id) === urlVariantId);
      if (!v || !Array.isArray(v.options)) return;

      tabsRoot.__urlVariantApplied = true;

      // Apply options -> inputs/selects
      optionsWithValues.forEach(o => {
        const pos = (o.position || 1) - 1;
        const desired = v.options[pos];
        if (!desired) return;

        const nm = optionInputNameFor(o.name);

        // Radio inputs
        const radio = document.querySelector(
          `input[name="${CSS.escape(nm)}"][value="${CSS.escape(desired)}"]`
        );
        if (radio && radio instanceof HTMLInputElement) {
          if (!radio.checked) radio.checked = true;
          radio.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          radio.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
          return;
        }

        // Select dropdowns (if any option is rendered as <select>)
        const select = document.querySelector(
          `select[name="${CSS.escape(nm)}"], select[name="options[${CSS.escape(o.name)}]"], select[name="options[${CSS.escape(o.name.toLowerCase())}]"]`
        );
        if (select && select instanceof HTMLSelectElement) {
          if (select.value !== desired) select.value = desired;
          select.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
          select.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        }
      });

      // Re-render panels + sync active tab after variant picker has processed events
      requestAnimationFrame(() => {
        renderAll();
      });
    }, 0);
  });


})();


